"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            Globalize.addCultureInfo("en", {
                messages: {
                    NavBar_HideNavigationPane: "Hide navigation pane",
                    NavBar_ShowNavigationPane: "Show navigation pane",
                    NavBar_ShowNavigationPaneHelpText: "(Alt+F1)",
                    NavigationPane_AddToFavorites: "Add to Favorites",
                    NavigationPane_AppLinks: "App links",
                    NavigationPane_Back: "Back",
                    NavigationPane_CloseModule: "Close module pane",
                    NavigationPane_CollapseAllToolTip: "Collapse all",
                    NavigationPane_CollapseToolTip: "Collapse the navigation pane",
                    NavigationPane_Company: "Company",
                    NavigationPane_Dashboard: "Dashboard",
                    NavigationPane_EmptyFavorites: "Favorites created using the navigation pane will show up here.",
                    NavigationPane_EmptyRecents: "A list of recently visited pages will display here after you have visited a few pages.",
                    NavigationPane_ExpandAllToolTip: "Expand all",
                    NavigationPane_ExpandToolTip: "Expand the navigation pane",
                    NavigationPane_Favorites: "Favorites",
                    NavigationPane_Gotit: "Got It!",
                    NavigationPane_Home: "Home",
                    NavigationPane_Landmark: "Navigation Menu",
                    NavigationPane_Loading: "Loading content",
                    NavigationPane_Modules: "Modules",
                    NavigationPane_MoveFirst: "Move to the first item",
                    NavigationPane_MoveLast: "Move to the last item",
                    NavigationPane_MoveNext: "Move to the next item",
                    NavigationPane_MovePrev: "Move to the previous item",
                    NavigationPane_NavigateItem: "Navigate to the selected item",
                    NavigationPane_NoSummaryData: "After visiting some pages, more links will appear here.",
                    NavigationPane_OpenForms: "Open forms",
                    NavigationPane_PinToolTip: "Pin navigation pane open",
                    NavigationPane_Recent: "Recent",
                    NavigationPane_RemoveFromFavorites: "Remove from Favorites",
                    NavigationPane_ShowAll: "Show all",
                    NavigationPane_ShowSummary: "Show summary",
                    NavigationPane_Sitemap: "Sitemap",
                    NavigationPane_WhatsNew: "You can expand only the menus you need, and do not worry, your menus will remain just as you left them. To see all of your menu options, click Expand all. ",
                    NavigationPane_WhatsNewToolTip: "Check out our menus!",
                    NavigationPane_Workspaces: "Workspaces",
                },
            });
            var GutterUtil;
            (function (GutterUtil) {
                function buildImageLink(imageObject) {
                    var imageContent;
                    switch (imageObject.ImageType) {
                        case $dyn.ui.ImageType.symbol:
                            var symbolClass = imageObject.Image + "-symbol";
                            if (symbolClass.match(/\s+/g)) {
                                symbolClass = "imageBinder-emptyImage";
                            }
                            var symbolClasses = "workspace-image " + symbolClass;
                            imageContent = (React.createElement("span", { className: symbolClasses, "data-dyn-title": imageObject.Label, "data-dyn-image-type": "Symbol" }));
                            break;
                        case $dyn.ui.ImageType.url:
                        case $dyn.ui.ImageType._axResource:
                            imageContent = (React.createElement("span", { className: "workspace-image", "data-dyn-title": imageObject.Label, "data-dyn-image-type": "Image" },
                                React.createElement("img", { className: "imageBinder-image", src: imageObject.Image })));
                            break;
                        case $dyn.ui.ImageType.base64:
                            var imageData = "data:image/png;base64," + imageObject.Image;
                            imageContent = (React.createElement("span", { className: "workspace-image", "data-dyn-title": imageObject.Label, "data-dyn-image-type": "Image" },
                                React.createElement("img", { className: "imageBinder-image", src: imageData })));
                            break;
                    }
                    return imageContent;
                }
                GutterUtil.buildImageLink = buildImageLink;
            })(GutterUtil = UI.GutterUtil || (UI.GutterUtil = {}));
            var ModulesPane = /** @class */ (function (_super) {
                __extends(ModulesPane, _super);
                function ModulesPane(props) {
                    var _this = _super.call(this, props) || this;
                    _this.Shortcuts = {
                        CollapseAll: {
                            Handler: function () {
                                DynReact.ModuleStore.menuExpandCollapseAll(DynReact.ModuleStore.getActiveLinks(), false);
                            },
                            Keys: { shift: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                        },
                        Escape: {
                            Description: function () {
                                var description = "";
                                if (DynReact.ModuleStore.getActiveModuleLabel()) {
                                    description = $dyn.label("NavigationPane_CloseModule");
                                }
                                else {
                                    description = $dyn.label("NavigationPane_CollapseToolTip");
                                }
                                return description;
                            },
                            Handler: function (event) {
                                // If the flyout is open, close it. Otherwise close the pane. Unless focus is in the aside pane.
                                if ($dyn.shell.eventIsInNavigationPane(event)) {
                                    if (DynReact.ModuleStore.getActiveModuleLabel()) {
                                        _this.closeFlyout();
                                    }
                                    else {
                                        if ($dyn.value($dyn.shell.isNavigationPanePinned)) {
                                            _this.props.ToggleIsPinned();
                                        }
                                        _this.collapsePane();
                                    }
                                }
                                else {
                                    return false;
                                }
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                            ShowToUser: function (target) {
                                return $dyn.shell.eventIsInNavigationPane({ target: target });
                            },
                        },
                        ExpandAll: {
                            Handler: function () {
                                DynReact.ModuleStore.menuExpandCollapseAll(DynReact.ModuleStore.getActiveLinks(), true);
                            },
                            Keys: { shift: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                        },
                        PinNavigationPane: {
                            Description: function () {
                                var description = "";
                                if ($dyn.value($dyn.shell.isNavigationPanePinned)) {
                                    description = $dyn.label("Shell_CloseNavPane");
                                }
                                else {
                                    description = $dyn.label("NavigationPane_PinToolTip");
                                }
                                return description;
                            },
                            Handler: function () {
                                _this.props.ToggleIsPinned();
                            },
                            Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.f1 },
                        },
                        SelectFirst: {
                            Description: $dyn.label("NavigationPane_MoveFirst"),
                            Handler: function (event) {
                                if ($dyn.shell.eventIsInNavigationPane(event)) {
                                    if (!DynReact.ModuleStore.getActiveModuleLabel()) {
                                        _this.setState({ selectedPaneItem: 0 });
                                    }
                                    else if (DynReact.ModuleStore.getActiveModuleLabel()) {
                                        _this.setState({ selectedFlyoutItem: 0 });
                                    }
                                }
                                else {
                                    return false;
                                }
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.home },
                            ShowToUser: function (target) {
                                return $dyn.shell.eventIsInNavigationPane({ target: target });
                            },
                        },
                        SelectLast: {
                            Description: $dyn.label("NavigationPane_MoveLast"),
                            Handler: function (event) {
                                if ($dyn.shell.eventIsInNavigationPane(event)) {
                                    if (!DynReact.ModuleStore.getActiveModuleLabel()) {
                                        _this.setState({ selectedPaneItem: _this.lastItem });
                                    }
                                    else if (DynReact.ModuleStore.getActiveModuleLabel()) {
                                        _this.setState({ selectedFlyoutItem: _this.lastFlyoutItem });
                                    }
                                }
                                else {
                                    return false;
                                }
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.end },
                            ShowToUser: function (target) {
                                return $dyn.shell.eventIsInNavigationPane({ target: target });
                            },
                        },
                        SelectNext: {
                            Description: $dyn.label("NavigationPane_MoveNext"),
                            Handler: function (event) {
                                if ($dyn.shell.eventIsInNavigationPane(event)) {
                                    if (!DynReact.ModuleStore.getActiveModuleLabel() && _this.state.selectedPaneItem < _this.lastItem) {
                                        _this.setState(function (prevState) { return ({ selectedPaneItem: prevState.selectedPaneItem + 1 }); });
                                    }
                                    else if (DynReact.ModuleStore.getActiveModuleLabel() && _this.state.selectedFlyoutItem < _this.lastFlyoutItem) {
                                        _this.setState(function (prevState) { return ({ selectedFlyoutItem: prevState.selectedFlyoutItem + 1 }); });
                                        DynReact.ModuleStore.whatsNewClose(); // Close whats new if we start moving around
                                    }
                                }
                                else {
                                    return false;
                                }
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.downArrow },
                            ShowToUser: function (target) {
                                return $dyn.shell.eventIsInNavigationPane({ target: target });
                            },
                        },
                        SelectPrevious: {
                            Description: $dyn.label("NavigationPane_MovePrev"),
                            Handler: function (event) {
                                if ($dyn.shell.eventIsInNavigationPane(event)) {
                                    if (!DynReact.ModuleStore.getActiveModuleLabel() && _this.state.selectedPaneItem > 0) {
                                        _this.setState(function (prevState) { return ({ selectedPaneItem: prevState.selectedPaneItem - 1 }); });
                                    }
                                    else if (DynReact.ModuleStore.getActiveModuleLabel() && _this.state.selectedFlyoutItem > 0) {
                                        _this.setState(function (prevState) { return ({ selectedFlyoutItem: prevState.selectedFlyoutItem - 1 }); });
                                        DynReact.ModuleStore.whatsNewClose(); // Close whats new if we start moving around
                                    }
                                }
                                else {
                                    return false;
                                }
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.upArrow },
                            ShowToUser: function (target) {
                                return $dyn.shell.eventIsInNavigationPane({ target: target });
                            },
                        },
                    };
                    _this.storeChanged = function () {
                        _this.setState(_this.getModuleStoreState(_this.state.recentsLoaded, _this.state.workspacesLoaded, _this.props.navigationModeIsWorkspace));
                    };
                    _this.togglePane = function () {
                        if (_this.props.navigationModeIsWorkspace) {
                            _this.props.ToggleIsPinned();
                        }
                        else {
                            if (!_this.props.PaneIsPinned) {
                                _this.props.setIsExpanded(!_this.props.paneIsExpanded);
                            }
                            else {
                                _this.props.setIsExpanded(true);
                            }
                        }
                    };
                    _this.paneOpenerKeyDown = function (evt) {
                        if ($dyn.util.isShortcutKeyPressed(evt.nativeEvent, { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] })) {
                            if (_this.props.navigationModeIsWorkspace) {
                                _this.props.ToggleIsPinned();
                            }
                            else {
                                _this.props.setIsExpanded(true);
                            }
                        }
                    };
                    _this.collapsePane = function () {
                        _this.props.setIsExpanded(false);
                    };
                    _this.keyHandler = function (event) {
                        // Narrow the type and only pass the native event
                        if ("nativeEvent" in event) {
                            event = event.nativeEvent;
                        }
                        $dyn.util.handleShortcuts(_this, event);
                    };
                    _this.setSelectedPaneItem = function (value) {
                        _this.setState({ selectedPaneItem: value });
                    };
                    _this.onFavoritesClicked = function () {
                        // Save initial expanded state before collapseAllGroups
                        var initialExpandedState = _this.state.favoritesAreExpanded;
                        _this.collapseAllGroups();
                        _this.closeFlyout();
                        if (!_this.props.paneIsExpanded && !_this.props.PaneIsPinned) {
                            _this.expandPane();
                            _this.setState({ favoritesAreExpanded: true, selectedPaneItem: 1 });
                        }
                        else {
                            _this.setState({ favoritesAreExpanded: !initialExpandedState, selectedPaneItem: 1 });
                        }
                    };
                    _this.onRecentsClicked = function () {
                        // Save initial expanded state before collapseAllGroups
                        var initialExpandedState = _this.state.recentsAreExpanded;
                        _this.collapseAllGroups();
                        _this.closeFlyout();
                        if (!_this.state.recentsLoaded) {
                            _this.loadRecents();
                        }
                        if (!_this.props.paneIsExpanded && !_this.props.PaneIsPinned) {
                            _this.expandPane();
                            _this.setState({ recentsAreExpanded: true, selectedPaneItem: 2 });
                        }
                        else {
                            _this.setState({ recentsAreExpanded: !initialExpandedState, selectedPaneItem: 2 });
                        }
                    };
                    _this.onWorkspacesClicked = function () {
                        // Save initial expanded state before collapseAllGroups
                        var initialExpandedState = _this.state.workspacesAreExpanded;
                        _this.collapseAllGroups();
                        _this.closeFlyout();
                        if (!_this.state.workspacesLoaded) {
                            _this.loadWorkspaces();
                        }
                        if (!_this.props.paneIsExpanded && !_this.props.PaneIsPinned) {
                            _this.expandPane();
                            _this.setState({ workspacesAreExpanded: true, selectedPaneItem: 3 });
                        }
                        else {
                            _this.setState({ workspacesAreExpanded: !initialExpandedState, selectedPaneItem: 3 });
                        }
                    };
                    _this.onModulesClicked = function () {
                        // Save initial expanded state before collapseAllGroups
                        var initialExpandedState = _this.state.modulesAreExpanded;
                        _this.collapseAllGroups();
                        var newSelectedIndex = 4;
                        // see if we had a active prior menuitem this can happen when going from modules to other node back to modules
                        // we want the active set so that the flyout pop open
                        if (DynReact.ModuleStore._activeModuleMenuItem === null && DynReact.ModuleStore._lastActiveModuleMenuItem) {
                            DynReact.ModuleStore._activeModuleMenuItem = DynReact.ModuleStore._lastActiveModuleMenuItem;
                        }
                        if (DynReact.ModuleStore._activeModuleMenuItem) {
                            for (var i = 0; i < _this.state.modules.length; i++) {
                                if (DynReact.ModuleStore.isActiveModule(_this.state.modules[i].menuItem)) {
                                    newSelectedIndex += i + 1;
                                    break;
                                }
                            }
                        }
                        if (!_this.props.paneIsExpanded && !_this.props.PaneIsPinned) {
                            _this.expandPane();
                            _this.setState({ modulesAreExpanded: true, selectedPaneItem: newSelectedIndex });
                        }
                        else {
                            // close the flyout
                            _this.closeFlyout();
                            _this.setState({ modulesAreExpanded: !initialExpandedState, selectedPaneItem: newSelectedIndex });
                        }
                    };
                    _this.setSelectedFlyoutItem = function (value) {
                        _this.setState({ selectedFlyoutItem: value });
                    };
                    _this.closeFlyout = function () {
                        DynReact.ModuleStore.changeActiveModule(null);
                        $dyn.whatsNew.closeWhatsNew($dyn.whatsNew.keyIds.navigationKey); // pane was open and is now closed - make sure to close the whats new
                    };
                    _this.setFlyoutItemCount = function (count) {
                        _this.lastFlyoutItem = count;
                    };
                    _this.expandPane = function () {
                        if (_this.props.navigationModeIsWorkspace) {
                            _this.props.ToggleIsPinned();
                        }
                        else {
                            _this.props.setIsExpanded(true);
                        }
                    };
                    _this.clickHandler = function (event) {
                        // Clicks outside the the modules pane should close the modules pane, unless they are in a flyout or aside pane or SuperTooltip (qtip)
                        if (event && event.target && !$(event.target).parents().hasClass("modulesPane") &&
                            !($dyn.flyout.flyoutManager.areAnyFlyoutsOpen() &&
                                !$dyn.util.flyout.IsClickInFlyout(event.target, $dyn.value($dyn.flyout.flyoutManager.getTopFlyout().flyout), event.pageX, event.pageY)) &&
                            !$dyn.util.flyout.wasLightboxClicked(event.target) &&
                            !$(event.target).parents().hasClass("asidePane") &&
                            !$(event.target).parents().hasClass("qtip")) {
                            _this.collapsePane();
                            event.stopPropagation();
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Closing Navigation Pane and stopPropagation on the keydown.");
                        }
                    };
                    _this.collapseAllGroups = function () {
                        // reset the panes to all collapsed
                        _this.setState({
                            favoritesAreExpanded: false,
                            modulesAreExpanded: false,
                            recentsAreExpanded: false,
                            workspacesAreExpanded: false,
                        });
                    };
                    _this.loadRecents = function () {
                        _this.setState({ recentsLoaded: true, recents: DynReact.ModuleStore.getRecents() });
                    };
                    _this.loadWorkspaces = function () {
                        _this.setState({ workspacesLoaded: true, workspaces: DynReact.ModuleStore.getWorkspaces() });
                    };
                    var _a = _this.getModuleStoreState(true, false, _this.props.navigationModeIsWorkspace), modules = _a.modules, favorites = _a.favorites, recents = _a.recents, workspaces = _a.workspaces;
                    _this.state = {
                        closedModule: "",
                        favorites: favorites,
                        favoritesAreExpanded: true,
                        modules: modules,
                        modulesAreExpanded: false,
                        navigating: false,
                        recents: recents,
                        recentsAreExpanded: false,
                        recentsLoaded: false,
                        selectedFlyoutItem: 0,
                        selectedPaneItem: 0,
                        workspaces: workspaces,
                        workspacesAreExpanded: false,
                        workspacesLoaded: false,
                    };
                    return _this;
                }
                ModulesPane.prototype.componentDidMount = function () {
                    DynReact.ModuleStore.addSubscription(this.storeChanged);
                    this._navigationCompleteEventSubscriberID = $dyn.shell.subscribeToNavigationCompleteEvent(this.onNavigating);
                    this.element.dynContext = { current: this };
                };
                ModulesPane.prototype.componentDidUpdate = function (prevProps) {
                    var _this = this;
                    if (!this._hostElement) {
                        this._hostElement = document.body.querySelector(".modulesPane");
                    }
                    this.element.dynContext = { current: this };
                    // Without the timeout, when the flyout is first expanded we don't get focus set correctly.
                    window.setTimeout(function () {
                        if (_this.props.paneIsExpanded) {
                            if (DynReact.ModuleStore.getActiveModuleLabel()) {
                                _this._selectedElement = _this._hostElement.querySelector(".modulesFlyout [data-dyn-selected=true]");
                                _this._selectedElement && _this._selectedElement.focus();
                                $dyn.log.focus && $dyn.log.focus("Focus: NavigationPane focused a flyout element.");
                            }
                            else {
                                _this._selectedElement = _this._hostElement.querySelector(".modulesList [data-dyn-selected=true]");
                                _this._selectedElement && _this._selectedElement.focus();
                                $dyn.log.focus && $dyn.log.focus("Focus: NavigationPane focused a module pane element.");
                            }
                        }
                        else if (prevProps.paneIsExpanded) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Focus NavPane opener after going from open to closed.");
                            _this.paneOpener && _this.paneOpener.focus();
                            DynReact.ModuleStore.whatsNewClose(); // pane was open and is now closed - make sure to close the whats new
                        }
                    });
                };
                ModulesPane.prototype.componentWillUnmount = function () {
                    DynReact.ModuleStore.removeSubscription(this.storeChanged);
                    $dyn.shell.unsubscribeToNavigationCompleteEvent(this._navigationCompleteEventSubscriberID);
                };
                ModulesPane.prototype.render = function () {
                    var _this = this;
                    var modulesContent;
                    var dockedContent;
                    var flyoutContent;
                    var modulesSubContent;
                    var flyoutClasses;
                    this.currentItem = 0;
                    if (!this.props.navigationModeIsWorkspace && this.props.paneIsExpanded && !this._listenersAreRegistered) {
                        this.registerListeners();
                    }
                    if (!this.props.paneIsExpanded && this._listenersAreRegistered) {
                        this.removeListeners();
                    }
                    var paneOpenerTitle = (this.props.PaneIsPinned) ? $dyn.label("NavigationPane_CollapseToolTip") : $dyn.label("NavigationPane_ExpandToolTip");
                    var paneOpenerContent = ($dyn.shell.CurrentShellViewPortWidthSize <= $dyn.shell.NavBarSizes.smallNavBarSize)
                        ? null
                        : (React.createElement("div", { "aria-expanded": this.props.paneIsExpanded, "aria-label": paneOpenerTitle, className: "modulesPane-opener", "data-dyn-expanded": this.props.paneIsExpanded, "data-dyn-helptext": $dyn.label("NavBar_ShowNavigationPaneHelpText"), "data-dyn-title": paneOpenerTitle, id: "modulesPaneOpener", onClick: this.togglePane, onKeyDown: this.paneOpenerKeyDown, onMouseEnter: this.onmouseenter, ref: function (ref) { return _this.paneOpener = ref; }, role: "button", tabIndex: 0 }));
                    if (this.props.navigationModeIsWorkspace) {
                        modulesContent = (React.createElement("div", { className: "gutterList", role: "navigation", "aria-label": $dyn.label("NavigationPane_Landmark"), tabIndex: -1 },
                            paneOpenerContent,
                            React.createElement("div", { className: "gutterWorkspaces", role: "tree", tabIndex: -1, "aria-label": $dyn.label("NavigationPane_Workspaces") },
                                this.renderGutterItems(this.state.workspaces.filter(function (menuItem) { return (menuItem.menuItemType !== "Action"); }), "Workspaces"),
                                this.renderGutterItems(this.state.workspaces.filter(function (menuItem) { return (menuItem.menuItemType === "Action"); }), "ActionWorkspaces")),
                            ";"));
                    }
                    else {
                        var pinClasses = "";
                        var pinLabel = "";
                        var closeButton = void 0;
                        var pinButton = void 0;
                        var modulesListClasses = "modulesList";
                        if (this.props.paneIsExpanded || this.props.PaneIsPinned) {
                            pinClasses = "modulesPane-pin " + (this.props.PaneIsPinned ? "Unpin-symbol" : "Pin-symbol");
                            pinLabel = this.props.PaneIsPinned ? $dyn.label("NavigationPane_CollapseToolTip") : $dyn.label("NavigationPane_PinToolTip");
                            closeButton = (React.createElement("button", { className: "modulesList-closeButton Cancel-symbol", type: "button", onClick: this.collapsePane, title: $dyn.label("NavBar_Close") }));
                            flyoutClasses = "modulesPane-flyout slideInL";
                            modulesListClasses += " modulesExpanded";
                            pinButton = (React.createElement("button", { className: pinClasses, type: "button", onClick: this.props.ToggleIsPinned, onMouseEnter: this.onmouseenter, title: pinLabel }));
                        }
                        if (this.isSingleColumnMode()) {
                            flyoutClasses += " modulesPane-isSingleColumn";
                        }
                        var favoritesID = "navPaneFavoritesID";
                        var recentsID = "navPaneRecentsID";
                        var workspaceID = "navPaneWorkSpaceGroupID";
                        var moduleID = "navPaneModuleID";
                        modulesSubContent = (React.createElement("div", { className: modulesListClasses, role: "tree", tabIndex: -1, onKeyDown: this.keyHandler },
                            React.createElement(UI.GutterPaneLink, { Id: "home", Image: "Home", ImageType: $dyn.ui.ImageType.symbol, key: "home", Label: $dyn.label("NavigationPane_Home"), Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem, TargetMethod: $dyn.ui.getNavBar().navigateToDashboard }),
                            this.renderItems([], false, true, "", ""),
                            React.createElement(UI.ModulesPaneGroup, { Expanded: this.state.favoritesAreExpanded, ExpandedGutter: this.props.paneIsExpanded || this.props.PaneIsPinned, Id: favoritesID, Image: "StarEmpty", ImageType: $dyn.ui.ImageType.symbol, Label: $dyn.label("NavigationPane_Favorites"), OnHeaderClick: this.onFavoritesClicked, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem }),
                            this.renderItems(this.state.favorites, this.state.favoritesAreExpanded, DynReact.ModuleStore.getNodeLoadingState($dyn.DynReact.TopLevelNavNodes.favorites), "NavigationPane_EmptyFavorites", "favorites"),
                            React.createElement(UI.ModulesPaneGroup, { Expanded: this.state.recentsAreExpanded, ExpandedGutter: this.props.paneIsExpanded || this.props.PaneIsPinned, Id: recentsID, Image: "Recent", ImageType: $dyn.ui.ImageType.symbol, Label: $dyn.label("NavigationPane_Recent"), OnHeaderClick: this.onRecentsClicked, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem }),
                            this.renderItems(this.state.recents, this.state.recentsAreExpanded, DynReact.ModuleStore.getNodeLoadingState($dyn.DynReact.TopLevelNavNodes.recents), "NavigationPane_EmptyRecents", "recent"),
                            React.createElement(UI.ModulesPaneGroup, { Expanded: this.state.workspacesAreExpanded, ExpandedGutter: this.props.paneIsExpanded || this.props.PaneIsPinned, Id: workspaceID, Image: "GenericApp", ImageType: $dyn.ui.ImageType.symbol, Label: $dyn.label("NavigationPane_Workspaces"), OnHeaderClick: this.onWorkspacesClicked, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem }),
                            this.renderItems(this.state.workspaces, this.state.workspacesAreExpanded, DynReact.ModuleStore.getNodeLoadingState($dyn.DynReact.TopLevelNavNodes.workspaces), "", "allworkspaces"),
                            React.createElement(UI.ModulesPaneGroup, { Expanded: this.state.modulesAreExpanded, ExpandedGutter: this.props.paneIsExpanded || this.props.PaneIsPinned, Id: moduleID, Image: "GroupedList", ImageType: $dyn.ui.ImageType.symbol, Label: $dyn.label("NavigationPane_Modules"), OnHeaderClick: this.onModulesClicked, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem }),
                            this.renderItems(this.state.modules, this.state.modulesAreExpanded, DynReact.ModuleStore.getNodeLoadingState($dyn.DynReact.TopLevelNavNodes.modules))));
                        var expandedGutterClasses = "gutterList";
                        if (this.props.paneIsExpanded) {
                            expandedGutterClasses += " showFullGutter";
                        }
                        modulesContent = (React.createElement("div", { className: expandedGutterClasses, role: "navigation", "aria-label": $dyn.label("NavigationPane_Landmark") },
                            paneOpenerContent,
                            modulesSubContent,
                            this.props.ViewportSize === $dyn.shell.ViewportSize.Small ? closeButton : pinButton));
                    }
                    if (this.props.navigationModeIsWorkspace) {
                        dockedContent = (React.createElement("div", { className: "modulesPane-gutter" }, paneOpenerContent));
                    }
                    else {
                        dockedContent = modulesContent;
                    }
                    if (this.props.paneIsExpanded) {
                        flyoutContent = (React.createElement("div", { className: flyoutClasses },
                            React.createElement(UI.ModulesFlyout, { BeforeNavigate: this.collapsePane, CloseFlyout: this.closeFlyout, IsPaneSingleColumn: this.isSingleColumnMode(), ReportFlyoutItemCount: this.setFlyoutItemCount, SelectedFlyoutItem: this.state.selectedFlyoutItem, SetSelectedFlyoutItem: this.setSelectedFlyoutItem })));
                    }
                    if (this.props.paneIsExpanded || this.props.PaneIsPinned || this.props.navigationModeIsWorkspace) {
                        this.lastItem = this.currentItem - 1;
                    }
                    if (this.props.navigationModeIsWorkspace) {
                        return (React.createElement("div", { ref: function (ref) { return _this.element = ref; } }, modulesContent));
                    }
                    else if (this.props.paneIsExpanded && this.isSingleColumnMode() && DynReact.ModuleStore.getActiveModuleLabel()) {
                        return (React.createElement("div", { ref: function (ref) { return _this.element = ref; } }, flyoutContent));
                    }
                    else {
                        return (React.createElement("div", { ref: function (ref) { return _this.element = ref; } },
                            dockedContent,
                            flyoutContent));
                    }
                };
                ModulesPane.prototype.renderGutterItems = function (itemList, featureName) {
                    var e_1, _a;
                    var items = [];
                    var itemsSize = itemList.length;
                    if (featureName === "Workspaces") {
                        this.currentItem++;
                        itemsSize++;
                        items.push(React.createElement(UI.GutterPaneLink, { Id: "home", Image: "Home", ImageType: $dyn.ui.ImageType.symbol, key: "home", Label: $dyn.label("NavigationPane_Home"), Posinset: this.currentItem, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem, Setsize: itemsSize, TargetMethod: $dyn.ui.getNavBar().navigateToDashboard }));
                    }
                    else if (featureName === "ActionWorkspaces" && itemList.length > 0) {
                        items.push(React.createElement("gutterPane-horizontalLine"));
                    }
                    if (itemList) {
                        try {
                            for (var itemList_1 = __values(itemList), itemList_1_1 = itemList_1.next(); !itemList_1_1.done; itemList_1_1 = itemList_1.next()) {
                                var item = itemList_1_1.value;
                                this.currentItem++;
                                if (item.menuItemType) {
                                    items.push(React.createElement(UI.GutterPaneLink, { Favorite: item.favorite, FeatureName: featureName, FormName: item.formName, Id: item.id, Image: item.image, ImageType: item.imageType, key: item.id, Label: item.label, MenuItemName: item.menuItem, MenuItemType: item.menuItemType, Posinset: this.currentItem, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem, Setsize: itemsSize }));
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (itemList_1_1 && !itemList_1_1.done && (_a = itemList_1.return)) _a.call(itemList_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    return items;
                };
                ModulesPane.prototype.renderItems = function (itemList, expanded, loading, emptyTextLabel, featureName) {
                    if (!this.props.navigationModeIsWorkspace && !this.props.paneIsExpanded && !this.props.PaneIsPinned) {
                        return null;
                    }
                    var items = [];
                    if (!expanded || !itemList) {
                        items = null;
                    }
                    else if (loading) {
                        items.push((React.createElement("div", { key: "loadingModulesDiv", className: "modulesFlyout-isLoading is-loading" }, $dyn.label("NavigationPane_Loading"))));
                    }
                    else if (itemList.length === 0 && expanded) {
                        items.push((React.createElement("div", { key: "emptyModulesDiv", className: "modulesFlyout-isEmpty" }, $dyn.label(emptyTextLabel))));
                    }
                    else {
                        for (var i = 0; i < itemList.length; i++) {
                            this.currentItem++;
                            var item = itemList[i];
                            if (item.menuItemType) {
                                items.push(React.createElement(UI.ModulePaneLink, { BeforeNavigate: this.collapsePane, Favorite: item.favorite, FeatureName: featureName, FormName: item.formName, Id: item.id, key: item.id, Label: item.label, MenuItemName: item.menuItem, MenuItemType: item.menuItemType, Posinset: i + 1, Selected: this.currentItem === this.state.selectedPaneItem, Setsize: itemList.length }));
                            }
                            else {
                                items.push(React.createElement(UI.ModulePaneModule, { ExpandPane: this.expandPane, isActive: DynReact.ModuleStore.isActiveModule(item.menuItem), isPhoneDevice: this.props.isPhoneDevice, isSingleColumnMode: this.isSingleColumnMode(), key: item.id, Label: item.label, MenuItemName: item.menuItem, PaneIsExpanded: expanded, Posinset: i + 1, Selected: this.currentItem === this.state.selectedPaneItem, SetSelectedPaneItem: this.setSelectedPaneItem, Setsize: itemList.length }));
                            }
                        }
                    }
                    this.currentItem++; // for the header
                    return items;
                };
                ModulesPane.prototype.getModuleStoreState = function (includeRecents, includeWorkspaces, navigationModeIsWorkspace) {
                    var modules = [];
                    if (!navigationModeIsWorkspace) {
                        var store = DynReact.ModuleStore.getModules();
                        // tslint:disable-next-line: forin
                        for (var key in store) {
                            modules.push(store[key]);
                        }
                        modules.sort(function (a, b) {
                            return a.label.localeCompare(b.label, Globalize.culture().name);
                        });
                    }
                    var state = {
                        favorites: DynReact.ModuleStore.getFavorites(),
                        modules: modules,
                    };
                    if (includeRecents && !navigationModeIsWorkspace) {
                        var tempModule = DynReact.ModuleStore.getRecents();
                        state.recents = tempModule.slice(0, DynReact.ModuleStore.maxRecents);
                    }
                    if (includeWorkspaces || navigationModeIsWorkspace) {
                        state.workspaces = DynReact.ModuleStore.getWorkspaces(navigationModeIsWorkspace);
                    }
                    return state;
                };
                ModulesPane.prototype.onNavigating = function (options) {
                    var doAfterFindContext = function () {
                        // Don't break if we don't get the data we needed.
                        if (Object.getOwnPropertyNames(DynReact.ModuleStore.getItemById(options.navigationItemId)).length > 0) {
                            DynReact.ModuleStore.addRecentlyUsedItem(options.navigationItemId);
                            var crumb_1 = DynReact.ModuleStore.getNavigationPath(options.navigationItemId);
                            if ($dyn.ui.getNavBar()) {
                                $dyn.ui.getNavBar().Crumbs(crumb_1);
                            }
                            window.setTimeout(function () {
                                DynReact.ModuleStore._requestMenuStructure("ReportMenuItemUsage", function () { }, { menuItem: options.navigationItemId + "#" + crumb_1 });
                            });
                        }
                    };
                    // For search results, we might not yet have the required navigation pane branch loaded yet
                    if (Object.getOwnPropertyNames(DynReact.ModuleStore.getItemById(options.navigationItemId)).length === 0) {
                        DynReact.ModuleStore.requestMenuForPath(options.NavigationPath, doAfterFindContext);
                    }
                    else {
                        doAfterFindContext();
                    }
                };
                ModulesPane.prototype.registerListeners = function () {
                    document.body.addEventListener("click", this.clickHandler, true);
                    document.body.addEventListener("keydown", this.keyHandler, true);
                    this._listenersAreRegistered = true;
                };
                ModulesPane.prototype.removeListeners = function () {
                    document.body.removeEventListener("click", this.clickHandler, true);
                    document.body.removeEventListener("keydown", this.keyHandler, true);
                    this._listenersAreRegistered = false;
                };
                ModulesPane.prototype.onmouseenter = function (event) {
                    $dyn.superTooltip.tryOpenSuperTooltip(event.target);
                };
                ModulesPane.prototype.isSingleColumnMode = function () {
                    return (this.props.ViewportSize === $dyn.shell.ViewportSize.Small || this.props.ViewportSize === $dyn.shell.ViewportSize.Medium);
                };
                return ModulesPane;
            }(React.Component));
            UI.ModulesPane = ModulesPane;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModulesPane.js.map
